import {FormPageTypes} from 'appRedux/actions/forms/types';

import {FORM_FIELD_TEMPLATE} from 'pages/admin/updateForm/partials/FormStructure/helper';

export const getCurrentPageBySection = (pages: FormPageTypes[], sectionId: number): FormPageTypes | null => {
    for (let i = 0, n = pages.length; i < n; i++) {
        const {sections} = pages[i];
        for (let j = 0, l = sections.length; j < l; j++) {
            const {id, fields} = sections[j];
            if (id === sectionId) {
                return pages[i];
            }
        }
    }
    return null;
};

export const checkIsTemplateFieldsPresented = (pages: FormPageTypes[], sectionId: number): boolean => {
    for (let i = 0, n = pages.length; i < n; i++) {
        const {sections} = pages[i];
        for (let j = 0, l = sections.length; j < l; j++) {
            const {id, fields} = sections[j];
            if (id === sectionId) {
                return fields.some(field => field.type === FORM_FIELD_TEMPLATE);
            }
        }
    }
    return false;
};
